/**
 * Filter array that all items contained are unique
 * @param array
 */
export const distinctArray = <T>(array: T[]) => {
    return array.filter(
        (item, i, arr) => arr.findIndex(otherItem => otherItem === item) === i
    );
};

export const sortArrayOfNumbers = (array: number[]) => array.sort((a, b) => a - b);
